import React, { useState } from 'react';
import { DATA } from '../data/urunler-data';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import LinkComponent from './LinkComponent';
import { variants } from '../script/animationVariants';
import { useTranslation } from 'react-i18next';

const HomeCategory = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language; // Mevcut dili alıyoruz

    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className='flex flex-col'>
            <LinkComponent />
            <div className='w-full bg-white grid grid-cols-14 customHScreen'>
                <motion.div
                    variants={variants.container}
                    initial="hidden"
                    animate="visible"
                    className='col-start-2 col-span-12 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-2'
                >
                    {DATA.map((item, index) => (
                        <div key={index} className='cursor-pointer'>
                            <motion.div
                                variants={variants.item}
                                whileInView={hoveredIndex === index ? "hover" : "visible"}
                                onHoverStart={() => setHoveredIndex(index)}
                                onHoverEnd={() => setHoveredIndex(null)}
                                className='relative group'
                            >













                                <Link to={item.link && `/sistemler/${item.link}`} key={index} className='relative z-10 block'>
                                    <motion.div
                                        className=' aspect-square pt-10 flex flex-col px-10 group relative'
                                        custom={index}
                                        whileInView="visible"
                                        initial="hidden"
                                        variants={variants.list}
                                    >


                                        <div className='h-1/3 w-full flex justify-end'>
                                            <motion.img
                                                src='/images/icons/arrow-white.svg'
                                                className='h-1/2 opacity-80 group-hover:opacity-100'
                                                variants={variants.arrow}
                                                animate={hoveredIndex === index ? "hover" : "default"}
                                                transition={{ duration: 0.3 }}
                                                alt="arrow"
                                            />
                                        </div>
                                        <div className='h-2/3 w-full'>
                                            <div className='h-1/2'>
                                                {/* <motion.img
                                                    src={`/images/anasayfa/category/${item.svg}`}
                                                    className='h-full opacity-50 group-hover:opacity-100 group-hover:scale-105'
                                                    variants={variants.image}
                                                    animate={hoveredIndex === index ? "hover" : "default"}
                                                    transition={{ duration: 0.3 }}
                                                    alt={item.name[currentLanguage]}
                                                /> */}
                                            </div>
                                            <div className='!text-white h-1/2 d flex flex-col justify-center group-hover:opacity-100 transition-all duration-300 text-25 font-thin'>
                                                <motion.h6
                                                    // variants={variants.text}
                                                    // animate={hoveredIndex === index ? "hover" : "default"}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    {item.name[currentLanguage]}
                                                </motion.h6>
                                            </div>
                                        </div>
                                    </motion.div>
                                </Link>
                                <div className='h-full w-full absolute top-0 left-0  '>
                                    {<img src={`/images/systems/${item.link}/cover.jpg`} className='h-full w-full object-cover' />}
                                </div>
                                <img 
                                        src='/images/filigran-square.png' 
                                        className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                                        alt=""
                                    />
                                <div className='h-full w-full bg-black absolute top-0 left-0 opacity-80 group-hover:opacity-0 duration-300'></div>



























                                
                            </motion.div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
};

export default HomeCategory;
